import { render } from "./XHSQR.vue?vue&type=template&id=50b9eb56"
import script from "./XHSQR.vue?vue&type=script&lang=js"
export * from "./XHSQR.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__